import { render, staticRenderFns } from "./TheLessonAttendance.vue?vue&type=template&id=381ab6aa&scoped=true&"
import script from "./TheLessonAttendance.vue?vue&type=script&lang=js&"
export * from "./TheLessonAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381ab6aa",
  null
  
)

export default component.exports